import React from 'react'

const EditCustomers = () => {
  return (
    <div>EditCustomers</div>
  )
}

export default EditCustomers